import { Routes } from '@angular/router';
import { AuthGuard } from './auth/guards/auth/auth.guard';
import { UserResolver } from './main-layout/resolvers/user/user.resolver';
import { ProcessingResolver } from './main-layout/resolvers/processing/processing.resolver';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./main-layout/main-layout.module').then(m => m.MainLayoutModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    title: 'Login',
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'signup',
    loadChildren: () => import('./signup/signup.module').then(m => m.SignupModule),
  },
  {
    path: 'forgot-password',
    title: 'Forgot Password',
    loadComponent: () => import('./unauth-pages/forgot-password/forgot-password.component').then(c => c.ForgotPasswordComponent),
  },
  {
    path: 'reset-password/:token',
    title: 'Reset Password',
    loadComponent: () => import('./unauth-pages/reset-password/reset-password.component').then(c => c.ResetPasswordComponent),
  },
  {
    path: 'verify-email/:token',
    data: { skipTitle: true },
    loadComponent: () => import('./unauth-pages/verify-email/verify-email.component').then(c => c.VerifyEmailComponent),
  },
  {
    path: 'error/:errorCode',
    data: { skipTitle: true },
    loadComponent: () => import('./pages/error-page/error-page.component').then(c => c.ErrorPageComponent),
  },
  {
    path: 'plans',
    title: 'Plans',
    loadComponent: () => import('./signup/pages/plans-page/plans-page.component').then(c => c.PlansPageComponent),
    resolve: {
      user: UserResolver
    }
  },
  {
    path: 'processing',
    data: { skipTitle: true },
    loadComponent: () => import('./signup/pages/processing-page/processing-page.component').then(c => c.ProcessingPageComponent),
    resolve: {
      user: ProcessingResolver
    }
  },
  {
    path: 'templates/:template',
    title: 'Templates',
    loadComponent: () => import('./signup/pages/template-preview/template-preview.component').then(c => c.TemplatePreviewComponent),
  },
  {
    path: 'oauth/authorize',
    data: { skipTitle: true },
    loadComponent: () => import('./main-layout/components/oauth2-authorize/oauth2-authorize.component').then(c => c.OAuth2AuthorizeComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'oauth/kit/authorize',
    data: { skipTitle: true },
    loadComponent: () => import('./main-layout/components/kit-oauth-setup/kit-oauth-setup.component').then(c => c.KitOAuthSetupComponent),
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'error/404',
  }
];
